import moment from 'moment';
import React from 'react';

class IEHelperClass {
  checkIfIE = (): boolean => {
    // tslint:disable-next-line: no-string-literal
    return navigator.userAgent.indexOf('MSIE') !== -1 || !!document['documentMode'];
  }

  displayBanner = (dispatch: any) => {
    if (this.checkIfIE()) {
      const beforeIECutoff = moment().isBefore(moment('08-17-2021', 'MM-DD-YYYY'));
      const message: JSX.Element = beforeIECutoff 
        ? <span>Microsoft will stop supporting Internet Explorer 11 on August 17, 2021. At that time, certain features may cease to work when accessing this service via IE11. For a better online experience, users should employ Chromium-based Edge or Google Chrome.</span>
        : <span>Microsoft has stopped supporting Internet Explorer 11 as of August 17, 2021. Certain features may cease to work or not be available when accessing this service via IE11. For a better online experience, the recommended browsers are Chromium-based Edge or Google Chrome. For additional support please contact <a href='mailto:us-iasvsupport@abb.com'>us-iasvsupport@abb.com</a>.</span>;
      dispatch({ type: 'ADD_BANNER', banners: [{ bannerType: 'warn', children: (<span>{message}</span>) }] });
    }
  }
}

export const IEHelper = new IEHelperClass();
